import ChevronLeft16 from '@carbon/icons-react/es/chevron--left/16';
import ChevronRight16 from '@carbon/icons-react/es/chevron--right/16';
import contains from 'document.contains';
import React, { FC, useEffect, useRef, useState } from 'react';
import { ClassNameOnlyProps } from 'components/ozone-component';
import { useDistractionFreeMode } from 'hooks/use-distraction-free-mode';
import { Sidebar } from './sidebar';

export const Peel: FC<ClassNameOnlyProps> = ({ children, className }) => {
  const [hovered, toggleHovered] = useState(false);
  const { active, enter, exit } = useDistractionFreeMode();
  const [collapsed, toggleCollapsed] = useState(active);
  const triggerRef = useRef(null);

  useEffect(() => {
    toggleCollapsed(!(!active || hovered));
  }, [hovered, active]);

  const onMouseMove = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    if (contains(triggerRef.current, e.target)) {
      e.stopPropagation();
      e.preventDefault();

      return;
    }

    if (active && !hovered) {
      toggleHovered(true);
    }
  };

  const onMouseLeave = () => {
    if (active && hovered) {
      toggleHovered(false);
    }
  };

  const onCollapse = () => {
    if (active) {
      exit();
    } else {
      enter();
    }

    toggleHovered(active);
  };

  return (
    <Sidebar
      className={className}
      $pinned={!active}
      collapsed={collapsed}
      trigger={
        <div ref={triggerRef}>
          {!active ? <ChevronLeft16 /> : <ChevronRight16 />}
        </div>
      }
      onCollapse={onCollapse}
      onMouseMove={onMouseMove}
      onMouseLeave={onMouseLeave}
    >
      {children}
    </Sidebar>
  );
};
